module.exports = __webpack_public_path__ + "media/images/olho-ea840025fdd12b37e01dae8dc12a866e.png";